export enum EventType {
	PROFILE_QUESTIONNAIRES_READY_EVENT = 'ProfileQuestionnairesReadyEvent',
	PROFILE_QUESTIONNAIRES_ANSWER_CHANGED_EVENT = 'ProfileQuestionnairesAnswerChangedEvent',
	PROFILE_QUESTIONNAIRES_CPI_MODAL_CLOSED = 'ProfileQuestionnairesCpiModalClosed',
	PROFILE_QUESTIONNAIRES_CPI_FILTERS = 'ProfileQuestionnairesCPIFilters',
	PROFILE_QUESTIONNAIRES_BESTFIT_AI_EVENT = 'ProfileQuestionnaireBestFitAIEvent',
}
